{
  "title": "Growth",
  "reflection": "Reflection",
  "reflections": "Reflections",
  "smallStepsCount": "Small steps count.",
  "dashboard": {
    "frequency": {
      "evenings": "Evenings",
      "weekly": "Weekly",
      "custom": "Custom",
      "off": "Off"
    },
    "format": {
      "json": "JSON",
      "csv": "CSV",
      "pdfSoon": "PDF coming soon"
    },
    "range": {
      "thirtyDays": "Last 30 days",
      "twelveMonths": "Last 12 months",
      "all": "All available"
    },
    "pdfSoonTitle": "PDF coming soon",
    "pdfSoonBody": "Choose JSON or CSV for now.",
    "chooseExportTitle": "Choose what to include",
    "chooseExportBody": "Select at least one export section.",
    "exportUnavailableTitle": "Export unavailable",
    "exportUnavailableBody": "Data export is available on Opncue Plus.",
    "goalsFull": "Goals are full",
    "saveNotesFailed": "Could not save notes",
    "tryAgain": "Try again in a moment.",
    "due": "Due",
    "dueDateLabel": "Due {{date}}",
    "overdueDateLabel": "Overdue, was due {{date}}",
    "archived": "Archived",
    "notesCount_one": "{{count}} note",
    "notesCount_other": "{{count}} notes",
    "reopenGoalA11y": "Reopen goal: {{goal}}",
    "completeGoalA11y": "Complete goal: {{goal}}",
    "editGoalA11y": "Edit goal: {{goal}}",
    "archiveGoalA11y": "Archive goal: {{goal}}",
    "deleteGoalA11y": "Delete goal: {{goal}}",
    "closeA11y": "Close progress",
    "weekTitle": "Your progress this week",
    "monthTitle": "Your progress this month",
    "summary": "Summary",
    "week": "Week",
    "month": "Month",
    "trends": "Trends",
    "yourSocialGoals": "Your social goals",
    "reflectionReminders": "Reflection reminders",
    "shareProgress": "Share your progress",
    "progressData": "Progress data",
    "encouragement": "Keep building real-life connections one step at a time.",
    "controlsA11y": "Dashboard controls",
    "trendEmpty": "Your trend appears here as you keep showing up.",
    "monthlyTitle": "Monthly view & trends",
    "monthlyBody": "See a monthly summary and your week-over-week trend with Opncue Plus.",
    "activeCount": "{{active}}/{{limit}} active",
    "goalsTab": "Goals ({{count}})",
    "archiveTab": "Archive ({{count}})",
    "noGoals": "No active goals yet.",
    "goalPlaceholder": "Ask someone from class to get coffee",
    "dueRequired": "Pick a due date to save this goal.",
    "archivedEmpty": "Archived goals will appear here.",
    "reflectionsEmpty": "No reflections yet. Log one after your next moment.",
    "openReflectionA11y": "Open reflection: {{source}}. {{outcome}}",
    "reflectNextMonth": "Reflect again next month",
    "addReflection": "Add a reflection",
    "quotaSummary": "{{used}}/{{limit}} reflections this month",
    "quotaSummaryUnlimited": "Unlimited reflections",
    "nudgeBody": "Choose when Opncue nudges you to reflect.",
    "weeklyEmail": "Weekly summary email",
    "weeklyEmailBody": "Get a gentle recap of your week by email.",
    "exportTitle": "Export progress",
    "exportBody": "Download your reflections, growth stats, and weekly summaries",
    "exportPlusBody": "Download your reflections, growth stats, and weekly summaries with Opncue Plus.",
    "closeExportA11y": "Close export options",
    "fileHelpTitle": "How to use this file",
    "fileHelpBody": "Keep this private. Open it in a spreadsheet, notes app, or personal archive when you want to review your growth.",
    "chooseFormat": "Choose format",
    "include": "Include",
    "dateRange": "Date range",
    "exportSections": {
      "growthStats": "Growth stats",
      "weeklySummaries": "Weekly summaries",
      "reflections": "Reflections",
      "privateNotes": "Private notes"
    },
    "preparing": "Preparing...",
    "export": "Export",
    "closeGoalA11y": "Close goal editor",
    "editGoal": "Edit goal",
    "notePlaceholder": "Note {{count}}",
    "removeNoteA11y": "Remove note {{count}}",
    "addNote": "Add note",
    "saveNotes": "Save notes",
    "closeControlsA11y": "Close dashboard controls",
    "controlsTitle": "Dashboard controls",
    "controlsBody": "Choose where your progress is counted from.",
    "reset": "Reset",
    "resetBody": "Count your metrics from this moment.",
    "goalsFullBody": "You have {{count}} active goals right now. Archive one to make room for a new goal.",
    "quotaIntroFree": "You have 3 reflections each month. Use them for moments that matter—a cue, a conversation, a small win, or even a quiet day.",
    "quotaIntroPlus": "Plus gives you more room to reflect, journal history, and deeper progress trends.",
    "weekday": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    },
    "customDaysLabel": "Which days",
    "customTimeLabel": "What time",
    "yourReflections": "Your reflections",
    "searchPlaceholder": "Search your notes",
    "clearSearchA11y": "Clear search",
    "filterOutcome": "Outcome",
    "filterAll": "All",
    "loadMore": "Load older",
    "historyEmpty": "Your reflections will appear here, and stay until you delete them.",
    "historyNoMatches": "No reflections match these filters.",
    "historyEnd": "That's everything.",
    "historyError": "Could not load your reflections.",
    "clearFilters": "Clear filters",
    "loadFailed": "Could not load your dashboard.",
    "retry": "Try again",
    "newGoal": "New goal",
    "goalPrompt": "What would you like to follow through on?",
    "dueDateOptional": "Due date · Optional",
    "notesOptional": "Notes · Optional",
    "createGoal": "Create goal",
    "saveGoal": "Save goal",
    "saveGoalFailed": "Could not save goal",
    "goalTextRequired": "Add a few words about what you'll do.",
    "pastDue": "Past due · {{date}}",
    "tabActive": "Active ({{count}})",
    "tabCompleted": "Completed ({{count}})",
    "tabArchived": "Archived ({{count}})",
    "openGoalA11y": "Open goal: {{goal}}",
    "goalMenuA11y": "More options for goal: {{goal}}",
    "closeGoalMenuA11y": "Close goal options",
    "deleteGoalTitle": "Delete this goal?",
    "deleteGoalBody": "“{{goal}}” will be permanently deleted. This cannot be undone.",
    "delete": "Delete",
    "cancel": "Cancel",
    "action": {
      "complete": "Mark as complete",
      "reopen": "Reopen",
      "edit": "Edit",
      "changeDue": "Change due date",
      "archive": "Archive",
      "restore": "Restore",
      "delete": "Delete"
    },
    "pageA11y": "Page {{page}}",
    "prevPageA11y": "Previous page",
    "nextPageA11y": "Next page",
    "completedEmpty": "Completed goals will appear here.",
    "filterDateRange": "When",
    "historyRange": {
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "3m": "Last 3 months",
      "12m": "Last 12 months",
      "custom": "Custom"
    },
    "rangeFrom": "From",
    "rangeTo": "To",
    "rangeFromA11y": "Start date",
    "rangeToA11y": "End date",
    "exportTruncatedTitle": "Export was shortened",
    "exportTruncatedBody": "Your journal is longer than one export can carry. Export a shorter range to get the rest.",
    "plusGate": {
      "goalsTitle": "Add More Goals with Plus",
      "goalsBody": "We want to keep Opncue ad-free and enjoyable to use. To make that possible, more active goals are available with Opncue Plus.",
      "monthlyTitle": "Unlock Monthly Trends with Plus",
      "monthlyBody": "See a monthly summary and week-over-week trends when you want the bigger picture.",
      "exportTitle": "Export Your Progress with Plus",
      "exportBody": "Download your reflections, growth stats, and weekly summaries when you want a copy for yourself.",
      "posterTitle": "Customize Progress Cards with Plus",
      "posterBody": "Unlock more poster styles and custom colors for the progress cards you share.",
      "reflectionsBody": "We want to keep Opncue ad-free and enjoyable to use. To make that possible, more journaling space is available with Opncue Plus.",
      "sharedBody": "We want to keep Opncue ad-free and enjoyable to use. To make that possible, some features are available with Opncue Plus.",
      "sharedBody2": "Your subscription helps us keep Opncue running, continue improving the app, and build new experiences for everyone.",
      "cta": "Upgrade to Plus",
      "dismiss": "Not now"
    },
    "trendNoDataTitle": "No progress yet",
    "trendNoDataBody": "Progress in this range will appear here.",
    "vibeCard": "Vibe card",
    "goalMovedToCompleted": "Moved to Completed: {{title}}",
    "undo": "Undo"
  },
  "exportData": {
    "title": "Opncue Progress Export",
    "privacyNote": "This is your private data. Keep it somewhere safe.",
    "howToUse": "Open this file in a text editor, spreadsheet app, or personal archive. Only share it with people you trust.",
    "section": "section",
    "field": "field",
    "value": "value",
    "date": "date",
    "type": "type",
    "feeling": "feeling",
    "outcome": "outcome",
    "note": "note",
    "truncatedNote": "This export was shortened — it does not contain your whole journal. Export a shorter date range to get the earlier entries."
  },
  "share": {
    "metrics": {
      "conversations": "Conversations",
      "reflections": "Reflections",
      "goalsCompleted": "Goals Completed",
      "unfinishedGoals": "Unfinished Goals",
      "groups": "Groups",
      "meetups": "Meetups"
    },
    "styles": {
      "classic": "Classic",
      "sky": "Sky",
      "mint": "Mint",
      "pink": "Pink",
      "ink": "Ink",
      "amber": "Amber",
      "violet": "Violet",
      "coral": "Coral",
      "ruby": "Ruby",
      "indigo": "Indigo",
      "lime": "Lime",
      "graphite": "Graphite",
      "custom": "Custom"
    },
    "brandSuffix": "Opncue.",
    "realSteps": "Real steps.",
    "realPeople": "Real people.",
    "customizeA11y": "Customize progress card",
    "useColorA11y": "Use {{color}} poster color",
    "customize": "Customize card",
    "pickColor": "Pick a poster color",
    "closeCustomizeA11y": "Close card customization",
    "pickHighlights": "Pick your progress highlights",
    "pickHighlightsBody": "Pick the 3 things to show on your card. Progress does not have to look perfect.",
    "plusSuffix": " (Plus)",
    "stats": {
      "practices": "Practice completed",
      "activePractice": "Practice active",
      "goalsAdded": "Goals started",
      "activeGoals": "Goals in progress",
      "goalsArchived": "Goals archived"
    },
    "outcome": {
      "clicked": "We clicked",
      "moreComfortable": "More comfortable than expected",
      "nervousStayed": "Nervous but stayed",
      "learnedAboutThem": "Learned about them",
      "learnedAboutMyself": "Learned about myself",
      "oneSided": "Felt one-sided"
    },
    "statGroups": {
      "practice": "Practice",
      "goals": "Goals",
      "reflections": "Reflections"
    },
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "headline": {
      "none": "This period was part of the story",
      "practice": "I made time for growth",
      "goals": "I kept an intention in sight",
      "reflections": "I paused to notice what was happening",
      "fallback": "I showed up"
    }
  },
  "reflectionFlow": {
    "closeA11y": "Close reflection",
    "upgrade": "Upgrade to Plus",
    "later": "Maybe later",
    "logged": "Logged.",
    "success": "Well done for reflecting today.",
    "remaining_one": "{{count}} reflection left this month.",
    "remaining_other": "{{count}} reflections left this month.",
    "backA11y": "Back",
    "where": "Where was this?",
    "subjectElsewhere": "What happened?",
    "subjectOpncue": "What are you reflecting on?",
    "feeling": "How did it feel?",
    "outcome": "How did it turn out?",
    "skip": "Skip",
    "remember": "Anything you want to remember?",
    "optionalNote": "Free text",
    "answerPlaceholder": "Type your answer",
    "saving": "Saving…",
    "log": "Log reflection",
    "limitTitle": "You’ve used your {{count}} reflections for this month.",
    "limitBodyPlus": "Small steps count. Come back tomorrow.",
    "limitBodyFree": "Small steps count. Come back next month, or upgrade for more journaling space.",
    "notePrefix": {
      "where": "Where: {{value}}",
      "subject": "What: {{value}}",
      "feeling": "Feeling: {{value}}",
      "outcome": "Outcome: {{value}}",
      "happened": "What happened: {{value}}",
      "stoodOut": "What stood out: {{value}}",
      "next": "Next: {{value}}"
    },
    "limitTitleFree": "Add More Reflections with Plus",
    "limitTitlePlus": "You’ve used your reflections for this month.",
    "happened": "What happened?",
    "stoodOut": "What stood out?",
    "feelNow": "How do you feel now?",
    "next": "What's next?",
    "rememberHint": "Optional. Just for you."
  },
  "options": {
    "where": {
      "opncue": "Opncue",
      "somewhereElse": "Outside Opncue",
      "other": "Other"
    },
    "subject": {
      "aCue": "A cue",
      "aConversation": "A conversation",
      "aGroup": "A group",
      "saidHi": "I said hi",
      "startedConversation": "I started a conversation",
      "joinedGroup": "I joined a group",
      "wentSomewhereSocial": "I went somewhere social",
      "repliedToSomeone": "I replied instead of avoiding",
      "metSomeoneNew": "I met someone new",
      "showedUp": "I showed up",
      "rested": "I took a break",
      "other": "Something else",
      "joinedIn": "I joined in",
      "reachedOut": "I reached out",
      "madePlan": "I made a plan",
      "triedSomethingDifficult": "I tried something difficult",
      "steppedAway": "I stepped away"
    },
    "feeling": {
      "good": "Good",
      "okay": "Okay",
      "awkward": "Awkward",
      "hardButTried": "Hard but I tried",
      "proud": "Proud",
      "drained": "Drained",
      "notMyVibe": "Not my vibe",
      "quiet": "Quiet",
      "other": "Other",
      "energised": "Energised",
      "comfortable": "Comfortable",
      "curious": "Curious",
      "unsure": "Unsure",
      "disappointed": "Disappointed"
    },
    "outcome": {
      "madeConnection": "I made a connection",
      "practiced": "I practiced",
      "learnedSomething": "I learned something",
      "notMyVibe": "It wasn't my vibe",
      "rested": "I rested",
      "noOutcomeYet": "No outcome yet",
      "other": "Something else",
      "clicked": "We clicked",
      "moreComfortable": "I felt more comfortable than I expected",
      "nervousStayed": "I was nervous, but stayed with it",
      "learnedAboutThem": "I learned something about them",
      "learnedAboutMyself": "I learned something about myself",
      "oneSided": "It felt one-sided",
      "nothingInParticular": "Nothing in particular"
    },
    "next": {
      "seeAgain": "I'd like to see them again",
      "followUp": "I'll follow up",
      "tryAgain": "I'd try this again",
      "practiceThis": "I want to practise this",
      "leaveHere": "I'll leave it here",
      "nothingNow": "Nothing for now",
      "other": "Other"
    }
  },
  "detail": {
    "closeA11y": "Close reflection",
    "title": "Reflection",
    "where": "Where",
    "whatHappened": "What happened",
    "feeling": "How it felt",
    "outcome": "Outcome",
    "note": "Note",
    "noNote": "No note added.",
    "encouragement": "Not every interaction has to become something.",
    "counts": "Reflecting still counts.",
    "delete": "Delete reflection",
    "deleteTitle": "Delete this reflection?",
    "deleteBody": "This removes it permanently. Nothing else ever deletes your reflections.",
    "deleteConfirm": "Delete",
    "deleteCancel": "Keep it",
    "deleteFailed": "Could not delete that reflection."
  },
  "metrics": {
    "reflections": "Reflections",
    "conversations": "Conversations",
    "groups": "Groups",
    "meetups": "Meetups",
    "cuesSent": "Cues sent",
    "cuesReceived": "Cues received",
    "goalsDone": "Goals done",
    "goalsRemoved": "Goals removed",
    "expiredGoals": "Expired goals",
    "meetupMoments": "Meetup moments",
    "steady": "Steady",
    "notEnoughData": "Not enough data",
    "noActivity": "No activity yet",
    "up": "Up",
    "down": "Down",
    "change": "{{direction}} {{percent}}%",
    "days": "days",
    "weeks": "weeks",
    "total": "{{total}} {{metric}} over {{count}} {{unit}}"
  },
  "dueDate": {
    "changeA11y": "Change due date",
    "addA11y": "Add a due date",
    "inputA11y": "Goal due date",
    "due": "Due {{date}}",
    "add": "Add due date"
  },
  "clearDueDateA11y": "Clear due date",
  "reminders": {
    "reflectionTitle": "A moment to reflect",
    "reflectionBody": "Anything from a recent interaction you’d like to look back on? Reflect when you’re ready.",
    "goalTitle": "Goal due soon",
    "goalBody_one": "“{{goal}}” is due in {{count}} day.",
    "goalBody_other": "“{{goal}}” is due in {{count}} days."
  },
  "reminderTime": {
    "at": "At {{time}}",
    "changeA11y": "Change reminder time",
    "inputA11y": "Reminder time"
  },
  "story": {
    "cards": {
      "practice": "Practice",
      "goals": "Goals",
      "reflections": "Reflections"
    },
    "openProgressA11y": "Open {{label}} progress",
    "relative": {
      "today": "Today",
      "yesterday": "Yesterday",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago"
    },
    "practice": {
      "completedCount_one": "{{count}} completed practice",
      "completedCount_other": "{{count}} completed practices",
      "none": "No completed practices yet",
      "activeCount_one": "{{count}} active practice",
      "activeCount_other": "{{count}} active practices",
      "mostPractised": "Most practised: {{label}}",
      "emptyBody": "Complete a practice to begin seeing your progress.",
      "completed": "Completed",
      "active": "Active practice",
      "bySkill": "Completed practice by skill",
      "recent": "Recent completed sessions"
    },
    "goals": {
      "completedCount_one": "{{count}} completed goal",
      "completedCount_other": "{{count}} completed goals",
      "startedCount_one": "{{count}} goal started",
      "startedCount_other": "{{count}} goals started",
      "activeNowCount": "{{count}} active now",
      "completed": "Completed",
      "started": "Started",
      "activeNow": "Active now",
      "rangeNoteWeek": "Completed and Started cover this week. Active now is your current open-goal count, whichever range you pick.",
      "rangeNoteMonth": "Completed and Started cover this month. Active now is your current open-goal count, whichever range you pick.",
      "followedThrough": "Followed through on",
      "noneThisWeek": "No goals completed this week",
      "noneThisMonth": "No goals completed this month",
      "goalTitle": "Goal: {{title}}",
      "completedOn": "Completed on: {{date}}"
    },
    "reflections": {
      "loggedCount_one": "{{count}} reflection logged",
      "loggedCount_other": "{{count}} reflections logged",
      "outsideCount": "{{count}} outside Opncue",
      "latest": "Latest: {{when}}",
      "logged": "Logged",
      "inside": "Inside Opncue",
      "outside": "Outside Opncue"
    }
  },
  "trend": {
    "metrics": {
      "practice": "Practice",
      "goals": "Goals",
      "reflections": "Reflections",
      "fallback": "Progress"
    },
    "context": {
      "goals": "{{started}} started · {{completed}} completed · {{archived}} archived",
      "reflections": "Based on what you told Opncue.",
      "practice": "Completed practices over time."
    }
  },
  "shareProgress": {
    "practiceCompleted_one": "{{count}} practice completed",
    "practiceCompleted_other": "{{count}} practices completed",
    "goalCompleted_one": "{{count}} goal completed",
    "goalCompleted_other": "{{count}} goals completed",
    "reflectionLogged_one": "{{count}} reflection logged",
    "reflectionLogged_other": "{{count}} reflections logged"
  }
}
